import Vue from 'vue'
import router from './router'
import store from './store/index'
import App from './app.vue'
import Element from 'element-ui'
// Vue.use(Element, { size: 'small', zIndex: 3000 })
Vue.use(Element)
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import './assets/css/index.scss'
import './assets/ali/iconfont.css'
import './assets/ali/iconfont.js'
import './assets/css/v3/index.scss'
import { _config, configData } from './configs/webConfig'
declare global {
    interface Window {
        eventBus: any
        baseConfig: configData
        createObjectURL: any
        hikEventTimer: any
        /**海康视频控件最大同时播放视频数量 */
        hikVideoCount: number
    }
}
window.eventBus = new Vue()
window.baseConfig = _config
window.hikEventTimer = null
window.hikVideoCount = 25

import { setAxiosIntercepters } from './api/common/axios'
setAxiosIntercepters()

import * as filters from '@/configs/filters'
import './configs/directives'
import './permission'

// 全局注册过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, (filters as any)[key])
})

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
    preLoad: 1,
    error: require('./assets/404_images/404_cloud.png'),
    loading: require('./assets/loading.gif'),
    attempt: 1
})

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: _config.BaiduMap.ak //'fLCzo41B9KjGEZl0HrSMLFbmFhqgLojs'
})

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

import 'viewerjs/dist/viewer.css'

//导入公用组件
import * as coms from '@/components/public'
//通用高级查询按钮
// Vue.use(btnAdvancedSearch)
// 全局注册通用组件
Object.keys(coms).forEach(key => {
    Vue.use((coms as any)[key])
})

Vue.config.productionTip = false
Vue.config.silent = true

const app = new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
})

export {
    app,
    router,
    store
}
